import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { ApprovalTrackingComponent } from '../../../Component/ApprovalTracking/approval-tracking/approval-tracking.component';

@Component({
  selector: 'app-tax-investment',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule, RouterOutlet, RouterModule, NgbDatepickerModule, NgSelectModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './tax-investment.component.html',
  styleUrl: './tax-investment.component.scss'
})
export class TaxInvestmentComponent {
  isDisabled: boolean = false;
  FinancialYears: any[] = [];
  TableDatas: any[] = [];
  user = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Filter = {
    SelectType: 'E',
    ESS_EmpTaxInvestmentID: 0,
    EmpMasterId: null,
    FinancialYearFrom: '',
    FinancialYearFromObj: '',
    FinancialYearTo: '',
    FinancialYearToObj: '',
    IsDraft: false,
    ApprovalStatus: 'ALL',
    ModuleMasterId: 10,
    ESS_TaxFinancialYearID: null,
  }

  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private toast: ToastService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private incometax: IncometaxService,
    private session: SessionService,
    protected dateFormat: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.Filter.EmpMasterId = this.user.UserId;
    this.ESS_TaxFinancialYearSelect();
  }

  FilterValidate(form: any) {
    if (form.valid) {
      if (this.Filter.ESS_TaxFinancialYearID == null || this.Filter.ESS_TaxFinancialYearID == 0) {
        this.Filter.FinancialYearFrom = '';
        this.Filter.FinancialYearTo = '';
      } else {
        this.Filter.FinancialYearFrom = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getFullYear() });
        this.Filter.FinancialYearTo = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getFullYear() });
      }
      this.ESS_EmpTaxInvestmentSelect();
    }
    else {
      form.submitted = true;
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_TaxFinancialYearSelect() {
    this.isDisabled = true;
    this.incometax.ESS_TaxFinancialYearSelect({ SelectType: 'S', ESS_TaxFinancialYearID: null, FinancialYearFrom: null, FinancialYearTo: null }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.FinancialYears = response.Table;
          this.FinancialYears.forEach(element => {
            element.FinancialYear = new Date(element.FinancialYearStart).getFullYear() + ' - ' + new Date(element.FinancialYearEnd).getFullYear();
          });

          this.Filter.ESS_TaxFinancialYearID = this.FinancialYears.filter(e => e.IsActive)[0].ESS_TaxFinancialYearID;
          this.ESS_EmpTaxInvestmentSelect();
        } else {
          this.FinancialYears = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpTaxInvestmentSelect() {
    this.isDisabled = true;
    this.incometax.ESS_EmpTaxInvestmentSelect(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
        } else {
          this.TableDatas = [];
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  clear() {
    // this.TableDatas = [];
    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.destroy();
    //   this.dtTrigger.next(null);
    // });
    this.ESS_EmpTaxInvestmentSelect();
  }

  Tracking(index: number) {
    const modalRef = this.modalService.open(ApprovalTrackingComponent, { size: 'lg' });
    modalRef.componentInstance.Detail.ModuleMasterId = this.Filter.ModuleMasterId;
    modalRef.componentInstance.Detail.EmpMasterId = this.Filter.EmpMasterId;
    modalRef.componentInstance.Detail.TransactionId = this.TableDatas[index].ESS_EmpTaxInvestmentID;
    modalRef.componentInstance.Detail.UserImage = this.TableDatas[index].Photo;
    modalRef.componentInstance.Detail.EmployeeName = this.TableDatas[index].EmpName;
    modalRef.componentInstance.Detail.EmpCode = this.TableDatas[index].EmpCode;
    modalRef.componentInstance.Detail.DesignationName = "";
    modalRef.result.then(result => { });
  }
}
